module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-7-54f9d76a2644e0fa93b4e1734b363893.png";